import { rem } from 'polished';
import React, { ComponentProps } from 'react';
import styled, { css } from 'styled-components';

import { Button } from '@vimeo/iris/components';
import { Input as IrisInput, Notice as N } from '@vimeo/iris/components';

export const FormSection = styled.section`
  margin-top: ${rem(10)};
`;

export const ContinueButton = styled(Button).attrs(({ format }) => ({
  format: format || 'primary',
  size: 'lg',
}))`
  width: 100%;
  &.f2pPilotRegLogin {
    background: var(--vimeo-colors-text-primary);
    margin-top: ${rem(24)};
    &:hover {
      background: var(--vimeo-colors-text-primary);
    }
  }
  &.styledCta {
    background: #17d5ff;
    color: #11191d;
    &:hover {
      background: #17d5ff;
      color: #11191d;
    }
  }
`;

export const OrSeparator = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--vimeo-colors-text-tertiary);
  padding: ${rem(12)} 0;
  font-size: ${rem(14)};
  &::before,
  &::after {
    position: relative;
    width: calc(50% - ${rem(16)});
    height: ${rem(1)};
    content: '\\a0';
    background-color: var(--vimeo-colors-stroke);
  }
`;

export const Notice = styled(N)`
  padding-right: ${rem(30)};
`;

export const HR = styled.hr`
  border: 1px solid var(--vimeo-colors-stroke);
  width: 100%;
  margin-bottom: ${rem(16)};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const InputWrapper = styled.div<{ formType?: string; order?: number }>`
  ${({ order }) =>
    order &&
    css`
      order: ${order};
    `}
  margin-bottom: ${rem(16)};
  span[role='alert'] {
    color: var(--vimeo-colors-status-destructive-primary);
  }

  input {
    padding: ${rem(16)} ${rem(8)};
    &::placeholder {
      color: var(--vimeo-colors-text-tertiary);
      opacity: 0.5;
    }
    &:focus::placeholder {
      color: transparent;
    }
  }
  &.f2pPilotRegLogin {
    input {
      padding: ${rem(8)} ${rem(12)};
      border-radius: ${rem(8)};
      border: ${rem(1)} solid var(--vimeo-colors-stroke);
      &::placeholder {
        color: var(--vimeo-colors-text-tertiary);
      }
    }
  }
  ${({ formType }) =>
    formType === 'underline' &&
    css`
      #email_login {
        text-align: center;
      }
      padding: 8px;
      margin-bottom: 0;
      input {
        padding: 15px;
        font-size: 17px;
        &:focus {
          border-bottom: 2px solid rgba(92, 201, 255, 0.9);
          transition: border-bottom 150ms ease;
        }
      }
    `}
`;

type Props = ComponentProps<typeof IrisInput> & {
  inputFieldVariant?: 'underline';
  formType?: string;
  order?: number;
  emailRef?: React.RefObject<HTMLInputElement | null>;
};

// Temp work around
export const Input = (props: Props) => (
  <InputWrapper formType={props.formType} order={props.order}>
    <IrisInput floating {...props} variant={props.inputFieldVariant} ref={props.emailRef}>
      {props.children}
    </IrisInput>
  </InputWrapper>
);
